import { useTranslation } from "react-i18next";
import { toast } from "sonner";
import { Button } from "@components/Button";
import { AddDocumentIcon } from "@components/icons";
import { Modal } from "@components/Modal/Modal";
import { useApiErrorUtils } from "@hooks/useApiErrorUtils";
import { useModal } from "@hooks/useModal";
import { type IUseModalProps } from "@store/modal/modal";
import { useSubscribeAdditionalServiceMutation } from "@services/additional-services/mutations";
import { GjensidgeTermsContent } from "./components/GjensidgeTermsContent/GjensidgeTermsContent";

interface IAdditionalServiceOrderConfirmModalProps extends IUseModalProps {
  jointBillServiceId: number;
  serviceId: number;
}

export const AdditionalServiceSubscribeConfirmModal: React.FC<
  IAdditionalServiceOrderConfirmModalProps
> = ({ jointBillServiceId, serviceId, ...rest }) => {
  const { t } = useTranslation();
  const modal = useModal(rest);
  const { toastApiError } = useApiErrorUtils();

  const { mutateAsync: orderService, isPending: isOrderLoading } =
    useSubscribeAdditionalServiceMutation(serviceId);

  const submitOrder = async () => {
    await orderService(jointBillServiceId)
      .then(() => {
        toast.success(
          t("additionalService.subscribeConfirmModal.toast.success"),
        );
      })
      .catch(toastApiError);

    modal.close();
  };

  return (
    <Modal
      modal={modal}
      title={t("additionalService.subscribeConfirmModal.title")}
      badgeProps={{ icon: AddDocumentIcon, color: "green" }}
      className="min-w-full lg:w-full xl:min-w-[72rem]"
      actionButtons={
        <>
          <Button onClick={modal.close} variant="secondary" className="w-full">
            {t("additionalService.subscribeConfirmModal.buttons.cancel")}
          </Button>
          <Button
            onClick={submitOrder}
            className="w-full"
            isLoading={isOrderLoading}
          >
            {t("additionalService.subscribeConfirmModal.buttons.accept")}
          </Button>
        </>
      }
    >
      <div className="overflow-y-auto lg:h-[60vh]">
        <GjensidgeTermsContent />
      </div>
    </Modal>
  );
};
